import Image from 'next/image'
import Link from 'next/link'

import * as S from './styles'
import LogoArquiteto from '../../../../public/img/logo-login.png'
import useAuth from 'hooks/useAuth'
import helpers from 'utils/helpers'
import UserIconMobile from '../../../../public/img/menu/icon-user-mobile.svg'
import { routes } from 'core/const/routes'
import config from 'config'
import * as Analytics from 'utils/analyticsevents'

type MenuFullMobileProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
  handleClickStartTutorialMobile?: () => void
  possuiConsultoriaPremium?: boolean
}

const MenuFullMobile = ({
  isOpen,
  setIsOpen,
  handleClickStartTutorialMobile,
  possuiConsultoriaPremium
}: MenuFullMobileProps) => {
  const { usuario, signOut } = useAuth()
  const primeiroNome = usuario?.nome && helpers.obterPrimeiroNome(usuario?.nome)

  return (
    <>
      <S.MenuFull aria-hidden={!isOpen} isOpen={isOpen}>
        <S.HeaderMenu>
          <Image
            src={LogoArquiteto}
            width={80}
            height={80}
            alt="Logo Arquiteto bolso"
          />

          <S.CloseMenu onClick={() => setIsOpen(false)} />
        </S.HeaderMenu>

        <S.UserMenuContainer>
          <S.UserIcon>
            <Image
              src={UserIconMobile}
              width={44}
              height={44}
              alt="Icone usuário"
            />
          </S.UserIcon>

          <S.UserInfoContent>
            <S.UserInfo reduzirNomeUsuario>
              <p>Olá, {''}</p> <strong>{primeiroNome}</strong>{' '}
            </S.UserInfo>
            <Link
              href={routes.dadosPessoais}
              passHref
              title="Editar dados pessoais"
            >
              Editar dados pessoais
            </Link>
          </S.UserInfoContent>
        </S.UserMenuContainer>

        <S.NavContainer className="gtm-app-header-menu">
          <Link href={routes.redefinirSenhaPainel} title="Alterar senha">
            <span
              className="passo-mf-alterar-senha"
              onClick={() =>
                Analytics.gtmHeaderMenuUsuario({ click_text: 'Alterar senha' })
              }
            >
              Alterar senha
            </span>
          </Link>
          <Link href={routes.presentes} title="Presentes">
            <span
              className="passo-mf-presentes"
              onClick={() =>
                Analytics.gtmHeaderMenuUsuario({ click_text: 'Presentes' })
              }
            >
              Presentes
            </span>
          </Link>
          <Link
            href="https://br.pinterest.com/arquitetodebolso/"
            title="Inspire-se"
            passHref
          >
            <a
              target="_blank"
              className="passo-mf-inspirese"
              onClick={() =>
                Analytics.gtmHeaderMenuUsuario({ click_text: 'Inspire-se' })
              }
            >
              Inspire-se
            </a>
          </Link>

          {possuiConsultoriaPremium && (
            <Link
              href="https://bit.ly/assistente-ab"
              passHref
              title="Assistente Virtual do AB"
            >
              <a
                target="_blank"
                className="passo-mf-assistenteab"
                onClick={() =>
                  Analytics.gtmHeaderMenuUsuario({
                    click_text: 'Assistente Virtual do AB'
                  })
                }
              >
                Assistente Virtual do AB
              </a>
            </Link>
          )}

          <Link
            href="https://api.whatsapp.com/send?phone=5511935033604"
            passHref
            title="Contato/Ajuda"
          >
            <a
              target="_blank"
              className="passo-mf-contato-ajuda"
              onClick={() =>
                Analytics.gtmHeaderMenuUsuario({ click_text: 'Contato/Ajuda' })
              }
            >
              Contato/Ajuda
            </a>
          </Link>

          {usuario?.perfil == config.PERFIL_CLIENTE && (
            <span
              onClick={() => {
                Analytics.gtmHeaderMenuUsuario({ click_text: 'Tutorial' })
                handleClickStartTutorialMobile &&
                  handleClickStartTutorialMobile()
              }}
            >
              Tutorial
            </span>
          )}
        </S.NavContainer>

        <S.ExitContainer>
          <span
            onClick={() => {
              Analytics.gtmHeaderMenuUsuario({ click_text: 'Sair' })
              signOut()
            }}
          >
            Sair
          </span>
        </S.ExitContainer>
      </S.MenuFull>
    </>
  )
}

export default MenuFullMobile
